/**
 * Startup keeps the stored zone in step with the device, unless the owner
 * picked one by hand on this device: then their choice wins.
 */
const KEY = "mioscape.timezonePinned";

export function timezonePinned(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function pinTimezone(): void {
  try {
    window.localStorage.setItem(KEY, "1");
  } catch {
    // Without storage the next launch syncs the device zone again.
  }
}
